import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../../query-factory';

export const useBanks = () =>
  useQuery({
    ...curatorQueries.accountInfo.banks,
  });
